"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PaletteIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaletteIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M12,4 C16.418278,4 20,7.581722 20,12 C20,12.4765562 19.9582193,12.9482753 19.8757513,13.4112283 C19.7322262,14.2169386 18.7344557,14.5185016 18.1686915,13.9271646 C17.6049714,13.3379642 16.8307335,13 16,13 C14.3431458,13 13,14.3431458 13,16 C13,16.8306261 13.3378916,17.6049109 13.9264057,18.1680046 L13.9264057,18.1680046 L14.0047646,18.2515329 C14.4873169,18.8261073 14.1786331,19.7365882 13.4124607,19.8746855 C12.9505877,19.9579349 12.4781639,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M9.5,14 C8.67157288,14 8,14.6715729 8,15.5 C8,16.3284271 8.67157288,17 9.5,17 C10.3284271,17 11,16.3284271 11,15.5 C11,14.6715729 10.3284271,14 9.5,14 Z M7.5,10 C6.67157288,10 6,10.6715729 6,11.5 C6,12.3284271 6.67157288,13 7.5,13 C8.32842712,13 9,12.3284271 9,11.5 C9,10.6715729 8.32842712,10 7.5,10 Z M15.5,8 C14.6715729,8 14,8.67157288 14,9.5 C14,10.3284271 14.6715729,11 15.5,11 C16.3284271,11 17,10.3284271 17,9.5 C17,8.67157288 16.3284271,8 15.5,8 Z M11.5,6 C10.6715729,6 10,6.67157288 10,7.5 C10,8.32842712 10.6715729,9 11.5,9 C12.3284271,9 13,8.32842712 13,7.5 C13,6.67157288 12.3284271,6 11.5,6 Z" })
  );
}